import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon, TargetIcon, EyeIcon, TrendingUpIcon, WalletIcon } from 'lucide-react';
const FEATURES = [{
  icon: ZapIcon,
  iconBg: 'bg-[#F59E0B]',
  title: 'Proceso Express con Avances Visibles',
  description: 'Aplicamos una metodología estratégica enfocada en generar avances desde las primeras etapas del proceso, para que puedas ver movimiento real en tu perfil sin esperar meses.'
}, {
  icon: TargetIcon,
  iconBg: 'bg-[#7B2FE0]',
  title: 'Estrategia 100% Personalizada',
  description: 'No trabajamos con disputas genéricas. Analizamos tu reporte, tus cuentas negativas y tus objetivos financieros para crear un plan diseñado específicamente para tu caso.'
}, {
  icon: EyeIcon,
  iconBg: 'bg-[#00B67A]',
  title: 'Transparencia en Cada Etapa',
  description: 'Te mantenemos informado durante el proceso, explicándote qué se está trabajando, por qué se hace y cómo va evolucionando tu perfil crediticio.'
}, {
  icon: TrendingUpIcon,
  iconBg: 'bg-[#3B82F6]',
  title: 'Optimización de Crédito Incluida',
  description: 'Te guiamos en la optimización de tu perfil crediticio, uso correcto de tus cuentas y preparación de ronda de aplicaciones, con el objetivo de ayudarte a maximizar tus aprobaciones y obtener mejores límites de crédito.'
}, {
  icon: WalletIcon,
  iconBg: 'bg-[#EC4899]',
  title: 'Financiamiento Sin Intereses',
  description: 'Contamos con planes de financiamiento internos al 0% de interés, diseñados para que puedas iniciar tu proceso con una inversión inicial accesible y pagar el balance restante en cómodas cuotas quincenales.'
}];
export function PorQueBrixen() {
  return <section className="w-full bg-white py-14 md:py-20 px-5" data-id="element-364">
      <div className="max-w-4xl mx-auto" data-id="element-365">
        <div className="text-center mb-12" data-id="element-366">
          <span className="inline-block bg-[#7B2FE0] text-white text-xs font-bold uppercase tracking-wider px-4 py-1.5 rounded-full mb-5" data-id="element-367">
            ¿Por Qué Brixen Credit?
          </span>
          <h2 className="text-2xl md:text-4xl font-extrabold text-[#0A0A0A]" style={{
          fontFamily: 'Manrope, Inter, sans-serif'
        }} data-id="element-368">
            Lo que nos diferencia
          </h2>
        </div>

        <div className="space-y-5" data-id="element-369">
          {FEATURES.map((feature, i) => {
          const Icon = feature.icon;
          return <motion.div key={feature.title} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.08
          }} className="flex items-start gap-4 bg-[#F5F5F5] rounded-2xl p-5 md:p-6" data-id="element-370">
                <div className={`flex-shrink-0 inline-flex items-center justify-center w-12 h-12 rounded-xl ${feature.iconBg} text-white shadow-md`} data-id="element-371">
                  <Icon className="w-6 h-6" data-id="element-372" />
                </div>
                <div data-id="element-373">
                  <h3 className="text-base md:text-lg font-bold text-[#0A0A0A] mb-1" style={{
                fontFamily: 'Manrope, Inter, sans-serif'
              }} data-id="element-374">
                    {feature.title}
                  </h3>
                  <p className="text-sm md:text-base text-gray-600 leading-relaxed" data-id="element-375">
                    {feature.description}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}